<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="form">
        <base-card>
          <v-card-title>Registrar Clientes FE</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                sm="4"
              >
                <v-text-field
                  ref="RazonSocial"
                  v-model="dataClient.RazonSocial"
                  label="Razón Social"
                  prepend-inner-icon="mdi-domain"
                  clearable
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  ref="RUC"
                  v-model="dataClient.RUC"
                  label="RUC"
                  prepend-inner-icon="mdi-card-account-details"
                  clearable
                  maxlength="13"
                  :rules="rucRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="5"
              >
                <v-text-field
                  ref="NombreCompania"
                  v-model="dataClient.NombreCompania"
                  label="Nombre Establecimiento"
                  prepend-inner-icon="mdi-account-tie"
                  clearable
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  ref="DireccionMatriz"
                  v-model="dataClient.DireccionMatriz"
                  label="Dirección Matriz"
                  prepend-inner-icon="mdi-store-marker"
                  clearable
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  ref="RucProveedorFE"
                  v-model="dataClient.RucProveedorFE"
                  label="RUC Proveedor FE"
                  prepend-inner-icon="mdi-card-account-details-outline"
                  clearable
                  maxlength="13"
                  :rules="rucRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="3"
              >
                <v-select
                  ref="Estado"
                  v-model="dataClient.Estado"
                  :items="typeEnvironment"
                  item-text="textEnvironment"
                  item-value="valueEnvironment"
                  label="Ambiente"
                  prepend-inner-icon="mdi-sitemap"
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col cols="12" sm="3">
                <v-combobox
                  v-model="dataClient.AppsSeleccionadas"
                  :items="appTypes"
                  prepend-inner-icon="mdi-apps"
                  label="Aplicaciones relacionadas"
                  :color= " isAppValid ? 'black' : '#ff3d57'"
                  @change="validateApps"
                  multiple
                />
                <p v-if="!isAppValid" style="color: #ff3d57; margin-top: -20px; font-size: 0.75rem;">
                  Este campo es requerido
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  ref="URLImagen"
                  v-model="dataClient.URLImagen"
                  label="URL Imagen Logo"
                  prepend-inner-icon="mdi-file-image"
                  clearable
                  :rules="formRules"
                  :error-messages="errorMessages"
                />
                Vista previa:
                <div
                  v-if="dataClient.URLImagen"
                  id="preview"
                >
                  <img
                    style="width:60%"
                    :src="dataClient.URLImagen"
                  >
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  ref="CorreoElectronico"
                  v-model="dataClient.CorreoElectronico"
                  label="Correo Electrónico"
                  prepend-inner-icon="mdi-email"
                  clearable
                  :rules="[
                    v => !!v || 'Este campo es requerido',
                    v => /.+@.+\..+/.test(v) || 'El correo no es válido'
                  ]"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>

              <v-col
                style="justify-content: end;display: flex;"
                cols="12"
                sm="12"
              >
                <v-btn
                  class="ma-2"
                  style="background-color:rgb(204 33 40);color:white !important"
                  :disabled="progress"
                  @click="validateClient"
                >
                  Registrar
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-alert
                v-show="successAlert"
                type="success"
                text
              >
                {{ msgSuccessAlert }}
              </v-alert>
            </v-row>
            <v-row
              v-if="progress === true"
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col cols="6">
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Registrando Cliente
                </v-col>
                <v-progress-linear
                  color="red darken-4"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </base-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import {listEnvironment} from '@/data/listEnvironment'

export default {
    name: 'RegistrarClients',

    data () {
      return {
        permisosRoles: ['administrador'],
        dataClient: {
          AppsSeleccionadas: ['FE'],
        },
        appTypesIncoming: [],
        isAppValid: true,
        URLImagen: '',
        NombreCompania: '',
        Estado: '',
        typeEnvironment: listEnvironment,
        errorMessages: '',
        successAlert: false,
        progress: false,
        msgSuccessAlert: 'Cliente registrado exitosamente',
        formRules: [
          (v) => !!v || 'Este campo es requerido',
        ],
        rucRules: [
          (v) => !!v || 'Este campo es requerido',
          (v) => /^\d{13}$/.test(v) || 'El RUC debe contener 13 dígitos numéricos',
        ],
      }
    },
    computed: {

      form () {
        return {
          NombreCompania: this.dataClient.NombreCompania,
          RazonSocial: this.dataClient.RazonSocial,
          RUC: this.dataClient.RUC,
          URLImagen: this.dataClient.URLImagen,
          Estado: this.dataClient.Estado,
          CorreoElectronico: this.dataClient.CorreoElectronico,
          DireccionMatriz: this.dataClient.DireccionMatriz,
          RucProveedorFE: this.dataClient.RucProveedorFE,
        }
      },
      statusResponseClient () {
        return this.$store.state.clients.statusResponse
      },
      appTypes () {
        this.appTypesIncoming = this.$store.state.clients.appTypes || []
       return this.appTypesIncoming.map(app => app.name)
      },
    },
    watch:
      {
        statusResponseClient () {
          if (this.statusResponseClient === true) {
            this.generateAlertSuccess()
            this.$store.dispatch('clients/setStatusResponse', false)
          }
        },
      },
    created() {
      this.getAppTypes()
    },
    methods: {

        generateAlertSuccess () {
          this.successAlert = true
          this.$store.dispatch('clients/getListClients')
          this.clearForm()
          setTimeout(() => {
            this.successAlert = false
          }, 5000)
        },
        clearForm () {
          this.$refs.form.reset()
        },
        validateClient () {
          this.validateApps()
          if (this.$refs.form.validate() && this.isAppValid) {
            this.sendClient()
          }
        },
        async sendClient () {
          this.dataClient.AppsSeleccionadas = this.appTypesIncoming
            .filter(app => this.dataClient.AppsSeleccionadas.includes(app.name))
            .map(app => app.id)
          this.progress = true
          try {
            await this.$store.dispatch('clients/insertClients', {
              ...this.dataClient,
            })
          } finally {
            this.progress = false
          }
        },
        validateApps() {
          this.isAppValid = this.dataClient.AppsSeleccionadas.length !== 0;
        },
        async getAppTypes () {
          await this.$store.dispatch('clients/getAppTypes')
        }
      },
    }
</script>
